/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall";

export default {
  async listRecentTransactions() {
    let data = { source: "Web" };
    let response = await apiCall("ledger/recent", data);
    return response;
  },

  async filterTransactions(data) {
    let response = await apiCall("ledger/filter", data);
    return response;
  },

  async updateLedger(ledgerId, amount, transactionDate, description, payee, transactionRef, tag) {
    let data = {
      ledger_id: ledgerId,
      amount: amount,
      transaction_date: transactionDate,
      description: description,
      payee: payee,
      transaction_reference: transactionRef,
      tag: tag,
    };
    let response = await apiCall("ledger/update", data);
    return response;
  },

  async importLedgers(ledgerFile) {
    let data = { ledger_file: ledgerFile };
    let response = await apiCall("ledger/import", data);
    return response;
  },

  async deleteLedger(ledgers) {
    let data = { ledgers: ledgers };
    return await apiCall("ledger/delete", data);
  },

  async filterAccountTransactions(accountId, page, openingDate, closingDate) {
    let data = {
      account_id: accountId,
      page: page,
      opening_date: openingDate,
      closing_date: closingDate,
    };
    let response = await apiCall("ledger/account", data);
    return response;
  },

  async fetchJournalEntries(data){
    let response = await apiCall("transaction/ledger/filter_journals", data);
    return response;
  },

  async postJournalEntry(data) {
    let response = await apiCall("transaction/journal/new_entry", data);
    return response;
  },

  async fetchLedgerApprovals(data) {
    let response = await apiCall("transaction/ledgerentryapproval/list_approvals", data);
    return response;
  },

  async approveEntry(data) {
    let response = await apiCall("transaction/ledgerentryapproval/approve_entry", data);
    return response;
  },
  async rejectEntry(data) {
    let response = await apiCall("transaction/ledgerentryapproval/reject_entry", data);
    return response;
  },
  async fetchApprovalStats() {
    let data = {};
    let response = await apiCall("transaction/ledgerentryapproval/stats", data);
    return response;
  },
  async lookupLedgerEntry(data) {
    let response = await apiCall("transaction/ledger/lookup_ledger", data);
    return response;
  },
  async updateLedgerEntryAccount(data) {
    let response = await apiCall("transaction/ledger/update_ledger_account", data);
    return response;
  },
  async updateDescription(data) {
    let response = await apiCall("transaction/ledger/update_description", data);
    return response;
  },

};
